/* global jQuery */
(function ($) {
	"use strict";

	$.modal.defaults = {
		"escapeClose": false,
		"clickClose": false,
		"showClose": false,
		"modalClass": "modal"
	};

	$.fn.catering = function (options) {
		var settings = $.extend({}, $.fn.catering.defaults, options);

		var sentPref = false;

		if (!settings.shopName) {
			console.log("Must pass shop name");
		}

		Date.prototype.addDays = function (days) {
			this.setDate(this.getDate() + days);
		};

		var getValidDates = function (zip, callback) {
			$.getJSON("/cart.js", function (cart) {
              
              var buffer = 1;
              
              console.log(cart.items.length);

              for (var k = 0; k < cart.items.length; k++) {
                console.log(k);
                if (cart.items[k].sku.charAt(2) === "2") buffer = 2;
              }
              
              $.get(settings.apiRoot + "/carrier/stores/" + settings.shopId + "/dates/valid/zip/" + zip + "/" + buffer, function (data) {
                if (data.status === "ok") {
                  callback(data.result);
                } else {
                  console.log(data);
                }
              });  

              
            }).fail(function (err) {
				console.log(err);
			});
		};

		var sendDatePref = function (zip, date) {

			$.getJSON("/cart.js", function (cart) {
				var items = [];

				for (var k = 0; k < cart.items.length; k++) {
					items.push({
						"gift_card": cart.items[k].gift_card,
						"grams": cart.items[k].grams,
						"handle": cart.items[k].handle,
						"id": cart.items[k].id,
						"line_price": cart.items[k].line_price,
						"price": cart.items[k].price,
						"product_id": cart.items[k].product_id,
						"product_title": cart.items[k].product_title,
						"quantity": cart.items[k].quantity,
						"requires_shipping": cart.items[k].requires_shipping,
						"sku": cart.items[k].sku,
						"title": cart.items[k].title,
						"variant_id": cart.items[k].variant_id,
						"variant_options": cart.items[k].variant_options,
						"variant_title": cart.items[k].variant_title,
						"vendor": cart.items[k].vendor
					});
				}
              
              	var hour = $("#hourpicker").val();

				$.post(settings.apiRoot + "/carrier/stores/" + settings.shopId + "/dates/setpref", {
					"zip": zip,
					"date": new Date(date).getTime(),
					"time": new Date().getTime(),
                  	"hour": hour,
					"items": items
				}).done(function (data) {
					console.log(data);
					$.modal.close();
					console.log("submitting form");
					sentPref = true;
					$(settings.checkoutName).click();
				})
				.fail(function (err) {
					console.log(err);
					$(settings.formName).submit();
				});

			}).fail(function (err) {
				console.log(err);
				$(settings.formName).submit();
			});
		};

		var validateEnabled = function (valid, enabled) {
			console.log([valid, enabled]);
			if (valid.length > 0) {
				var validEnabled = [];

				for (var i = 0; i < enabled.length; i++) {
					var checkDate = enabled[i];

					var v = false;

					for (var k = 0; k < valid.length; k++) {
						if ((valid[k][0] === checkDate[0]) && (valid[k][1] === checkDate[1]) && (valid[k][2] === checkDate[2])) {
							v = true;
							break;
						}
					}
					if (v) validEnabled.push(checkDate);
				}

				return validEnabled;
			}

			return enabled;
		};

		$("body").append("<div id=\"submit_modal\" class=\"modal\"><p>Submitting date preference...</p></div>");

		this.pickadate(settings.pickadate);

		var picker = this.pickadate("picker");

		var container = $(".picker__holder");

		var topPanel = $(document.createElement("div"))
			.addClass("d-datepicker-toppanel")
			.prependTo(container);

		if (settings.zip) {

			$(document.createElement("span"))
				.html("Ship-to zip code:&nbsp;")
				.addClass("d-datepicker-text")
				.appendTo(topPanel);

			var zip = $(document.createElement("input"))
				.addClass("d-datepicker-zip")
				.attr({
					"type": "text",
					"maxlength": 5
				})
				.appendTo(topPanel);

			this.focus(function () {
				zip.focus();
			});


			if (settings.before) {
				$(document.createElement("span"))
					.html("When:&nbsp;")
					.addClass("d-datepicker-text")
					.appendTo(topPanel);

				$(document.createElement("select"))
					.addClass("d-datepicker-when")
					.append($("<option>").attr("value", "on").attr("selected", "selected").text("On"))
					.append($("<option>").attr("value", "by").text("By or Before"))
					.appendTo(topPanel);
			}

			var haveZip = false;

			zip.on("input", function () {
				if (zip.val().length < 5) {
					if (haveZip) {
						haveZip = false;
						picker.set("disable", true).render();
					}
				} else {
					haveZip = true;
                    if (["10019", "10020", "10103", "10105", "10106", "10107", "10111", "10112",
                        "10036", "10110", "10018", "10001", "10118", "10119", "10122", "10123",
                        "10011", "10014", "10012", "10023", "10024", "10022", "10151", "10152", 
                        "10153", "10154", "10155", "10017", "10165", "10167", "10168", "10169", 
                        "10170", "10171", "10172", "10173", "10174", "10175", "10176", "10177", 
                        "10016", "10158", "10055", "10010", "10012", "10013", "10003", "10009", 
                        "10006", "10271", "10038", "10270", "10005", "10004", "10041", "10007", 
                        "10008", "10101", "10104", "10108", "10113", "10116", "10120", "10121", 
                        "10150", "10159", "10166", "10178", "10249", "10256", "10268", "10276", 
                        "10278", "10279", "10280", "10281", "10286", "10065", "10021", "10002",
                        "10025", "10028", "10075", "10162", "10128", "10029"].indexOf(zip.val()) === -1) {

                      $(container).prepend('<p style="padding-left: 10px;" id="sorry">Sorry but your zipcode is out of the catering area</p>');  	
                    } else {
                      getValidDates(zip.val(), function (data) {
                          picker.set("min", Number(data.min));
                          picker.set("max", Number(data.max));

                          data.enabled = validateEnabled(settings.validDates, data.enabled);

                          picker.set("disable", data.enabled).render();
                      });
                    }
				}
			});
		} else {
			getValidDates("", function (data) {
				picker.set("min", Number(data.min));
				picker.set("max", Number(data.max));

				data.enabled = validateEnabled(settings.validDates, data.enabled);

				picker.set("disable", data.enabled).render();
			});
		}


		if (settings.required) {
			$(settings.checkoutName).addClass("disabled");
		}

		$(settings.checkoutName).click(function (event) {
			if ((!sentPref) && picker.get() && $("#hourpicker").get() && ($("#hourpicker").val().length > 1)) {
				$("#submit_modal").modal();
				console.log("overriding form");
				event.preventDefault();
				console.log("sending date pref" + picker.get());
				sendDatePref(zip.val(), picker.get());
			} else if (settings.required && (!picker.get() || !$("#hourpicker").val())) {
				event.preventDefault();
				console.log("opening");
				picker.open();
			}
			sentPref = false;
		});

		this.change(function () {
		  $(settings.checkoutName).removeClass("disabled");
          
          $("#hourpicker").remove();
              
          if (picker.get()) {
            
        	$('#houerpickerholder').append('<input id="hourpicker" type="input" name="attributes[deliveryhour]"/>');
            
            var day = new Date(picker.get());
            if ((day.getDay() == 6) || (day.getDay() == 0)) {
            	$("#hourpicker").pickatime({
            		min: [8,0],
            		max: [17,0]
          		});
            } else {
            	$("#hourpicker").pickatime({
            		min: [7,30],
            		max: [18,0]
          		});
            }
          }
		});

		return this;
	};

	$.fn.catering.defaults = {
		"zip": true,
		"before": false,
		"apiRoot": "https://api.decimal.io/v1",
		"pickadate": {
			"format": "mm/dd/yyyy",
			"disable": [true],
			"min": new Date()
		},
		"formName": "#cartform",
		"checkoutName": "button[name=checkout]",
		"required": true,
		"validDates": []
	};

}(jQuery));